import { ProfessionalCategory } from "../Model/ProfessionalCategory";


export class GetProfessionalCategoriesList {
    constructor(
      total,
      offset,
      limit,
      records,
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
      return new GetProfessionalCategoriesList(
        data.total,
        data.offset,
        data.limit,
        data.records.map((record) => {
          return ProfessionalCategory.createFromResponseData(record);
        }),
      );
    }
  };